// extracted by mini-css-extract-plugin
export default {"popoverProjectMenu":"PopoverProjectComponent_popoverProjectMenu__5LM2r","popoverProjectItem":"PopoverProjectComponent_popoverProjectItem__bqR3T"};